/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Consultation } from './Consultation';
import {
    ConsultationFromJSON,
    ConsultationFromJSONTyped,
    ConsultationToJSON,
    ConsultationToJSONTyped,
} from './Consultation';

/**
 * 
 * @export
 * @interface ConsultationsResponsePaginated
 */
export interface ConsultationsResponsePaginated {
    /**
     * 
     * @type {Array<Consultation>}
     * @memberof ConsultationsResponsePaginated
     */
    consultations?: Array<Consultation>;
    /**
     * 
     * @type {number}
     * @memberof ConsultationsResponsePaginated
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsultationsResponsePaginated
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ConsultationsResponsePaginated
     */
    totalElements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConsultationsResponsePaginated
     */
    last?: boolean;
}

/**
 * Check if a given object implements the ConsultationsResponsePaginated interface.
 */
export function instanceOfConsultationsResponsePaginated(value: object): value is ConsultationsResponsePaginated {
    return true;
}

export function ConsultationsResponsePaginatedFromJSON(json: any): ConsultationsResponsePaginated {
    return ConsultationsResponsePaginatedFromJSONTyped(json, false);
}

export function ConsultationsResponsePaginatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsultationsResponsePaginated {
    if (json == null) {
        return json;
    }
    return {
        
        'consultations': json['consultations'] == null ? undefined : ((json['consultations'] as Array<any>).map(ConsultationFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'last': json['last'] == null ? undefined : json['last'],
    };
}

export function ConsultationsResponsePaginatedToJSON(json: any): ConsultationsResponsePaginated {
    return ConsultationsResponsePaginatedToJSONTyped(json, false);
}

export function ConsultationsResponsePaginatedToJSONTyped(value?: ConsultationsResponsePaginated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consultations': value['consultations'] == null ? undefined : ((value['consultations'] as Array<any>).map(ConsultationToJSON)),
        'page': value['page'],
        'size': value['size'],
        'totalElements': value['totalElements'],
        'last': value['last'],
    };
}

